import { render } from "./ResponsiveDiv.vue?vue&type=template&id=3795f4ba"
import script from "./ResponsiveDiv.vue?vue&type=script&lang=js"
export * from "./ResponsiveDiv.vue?vue&type=script&lang=js"
script.render = render

export default script